const CreateCheckbox_mutate = `
  mutation createCheckbox(
    $formId: Int!
    $label: String!
    $mandatory: Boolean
    $caption: String
    $tooltip: String    
    $options: [String!]!
    ) {
    createCheckbox(
      formId: $formId,
      label: $label,
      mandatory: $mandatory,
      caption: $caption,
      tooltip: $tooltip,      
      options: $options) 
      {
        component {
          componentId
          caption
          tooltip
          order
          componentId
          label
          mandatory          
        }
      }
    }
`;

const EditCheckBox_mutate = `
  mutation editCheckBox(
    $componentId: Int!
    $label: String!  
    $mandatory: Boolean
    $caption: String
    $tooltip: String
    $options: [String!]!
    ) {
    editCheckbox(
      componentId: $componentId,
      label: $label,
      mandatory: $mandatory,
      caption: $caption,
      tooltip: $tooltip,
      options: $options) 
      {
        component {
          componentId
          answerList{
            answerId 
            label
            value
          }
          caption
          tooltip
          order
          label
          mandatory          
        }
      }
    }
`;

module.exports = {
  CREATE_CHECKBOX_MUTATION: CreateCheckbox_mutate,
  EDIT_CHECKBOX_MUTATION : EditCheckBox_mutate,
};
